export const API_URL_MARKET = "/market";
export const API_URL_MARKET_SKIN_PRICE = "/market/skins-price";
